import { Component, Injector, Optional, Input } from '@angular/core';

import { PakbonregelService } from 'src/app/core/service/pakbonregel.service';
import { Pakbonregel } from 'src/app/core/dto/pakbonregel';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Pakbon } from 'src/app/core/dto/pakbon';
import { Projectregel } from 'src/app/core/dto/projectregel';

@Component({
    selector: 'c-i-j-borculo-pakbonregel-collection',
    templateUrl: './pakbonregel-collection.component.html'/*,
    styleUrls: ['./pakbonregel-collection.component.css'] */
})
export class PakbonregelCollectionComponent extends PagedCollectionComponent<Pakbonregel> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Pakbonregel>([
		{ colDef: 'pakbon', prop: x => x.pakbon.pakbonnummer, searchable: SearchableType.String },
		{ colDef: 'projectregel', prop: x => x.projectregel.id, searchable: SearchableType.String },
    { colDef: 'soort', prop: x => x.projectregel.instrument.soort, searchable: SearchableType.String },
    { colDef: 'merk', prop: x => x.projectregel.instrument.merk, searchable: SearchableType.String },
    { colDef: 'type', prop: x => x.projectregel.instrument.type, searchable: SearchableType.String },
    { colDef: 'prijsArtikelen', prop: x => x.projectregel.prijsArtikelen, searchable: SearchableType.Number },
    { colDef: 'kalibratiePrijs', prop: x => x.projectregel.kalibratiePrijs, searchable: SearchableType.Number },
    { colDef: 'prijsBlock', prop: x => x.projectregel.prijsBlock},
    { colDef: 'prijsKalibratie', prop: x => x.projectregel.prijsKalibratie},
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: PakbonregelService, @Optional() protected filter: Filter<Pakbonregel>, injector: Injector) {
        super('/pakbonregel/pakbonregel', injector, Pakbonregel);

		  this.initInput('pakbon', this.filterBuilder.equal(x => x.pakbon.id));
      this.initInput('projectregel', this.filterBuilder.equal(x => x.projectregel.id));

      this.filter.onGetChipLabel(x => x.pakbon.pakbonnummer, () => 'Pakbonnummer');
      this.filter.onGetChipLabel(x => x.projectregel.id, () => 'Bonnr.');
      this.filter.onGetChipLabel(x => x.projectregel.instrument.soort, () => 'Soort');
      this.filter.onGetChipLabel(x => x.projectregel.instrument.merk, () => 'Merk');
      this.filter.onGetChipLabel(x => x.projectregel.instrument.type, () => 'Type');
      this.filter.onGetChipLabel(x => x.projectregel.kalibratiePrijs, () => 'Kalibratie Prijs');
      this.filter.onGetChipLabel(x => x.projectregel.prijsArtikelen, () => 'Prijs Artikelen');
      this.filter.onGetChipLabel(x => x.projectregel.prijsBlock, () => 'Prijs Block');
      this.filter.onGetChipLabel(x => x.projectregel.prijsKalibratie, () => 'Prijs Kalibratie');

    }

    @Input() set pakbon(val: Pakbon) { this.handleInput('pakbon', val.id); }
    @Input() set projectregel(val: Projectregel) {this.handleInput('projectregel', val.id); }

	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'pakbon' && this.pakbon != null) { return false; }
    if(colDef.colDef == 'projectregel' && this.pakbon == null) { return false; }
    if(colDef.colDef == 'prijsBlock' && this.pakbon == null) { return false; }
    if(colDef.colDef == 'prijsKalibratie' && this.pakbon == null) { return false; }

		return super.displayColumn(colDef, ix);
	}

  showKalibratiePrijs(kalibratiePrijs : string, prijsBlock: boolean, externePrijs:string){
    if (prijsBlock){
        return externePrijs;
    } else {
        return kalibratiePrijs;
    }
  }

  canDelete() {
    return false;
  }
}